import { Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function Breadcrumbs({ icon, title, route, light }) {
  const navigate = useNavigate()
  const isAdmin = route.includes('admin');
  const routes = route.slice(0, -1);
  return (
    <SoftBox mr={{ xs: 0, xl: 8 }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
          },
        }}
      >
        { }
        <Link to={`${localStorage.getItem("scope") === '1' ? '/admin/dashboard' : '/'}`}>
          <SoftTypography
            component="span"
            variant="caption"
            color={light ? "white" : "dark"}
            opacity={light ? 0.8 : 0.5}
            sx={{ lineHeight: 0 }}
          >
            <Icon>{icon}</Icon>
          </SoftTypography>
        </Link>
        {routes.map((el, i) => {

          return (
            <>
              {isAdmin ? (
                <span onClick={() => navigate(-1)} key={el} style={{ cursor: "pointer" }}>
                  <SoftTypography
                    component="span"
                    variant="button"
                    fontWeight="regular"
                    textTransform="capitalize"
                    color={light ? "white" : "dark"}
                    opacity={light ? 0.8 : 0.5}
                    sx={{ lineHeight: 0 }}
                  >
                    {el}
                  </SoftTypography>
                </span>
              ) : (
                <Link to={`/${el}`} key={el}>
                  <SoftTypography
                    component="span"
                    variant="button"
                    fontWeight="regular"
                    textTransform="capitalize"
                    color={light ? "white" : "dark"}
                    opacity={light ? 0.8 : 0.5}
                    sx={{ lineHeight: 0 }}
                  >
                    {el}
                  </SoftTypography>
                </Link>
              )}
            </>

          )
        })}
        {
          title.length !== 24 &&
          <SoftTypography
            variant="button"
            fontWeight="regular"
            textTransform="capitalize"
            color={light ? "white" : "dark"}
            sx={{ lineHeight: 0 }}
          >
            {title.replace(/-/g, " ")}
          </SoftTypography>
        }

      </MuiBreadcrumbs>
      {
        title.length !== 24 &&
        <SoftTypography
          variant="button"
          fontWeight="regular"
          textTransform="capitalize"
          color={light ? "white" : "dark"}
          sx={{ lineHeight: 0 }}
        >
          {title.replace(/-/g, " ")}
        </SoftTypography>
      }
    </SoftBox>
  );
}

// Setting default values for the props of Breadcrumbs
Breadcrumbs.defaultProps = {
  light: false,
};

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
};

export default Breadcrumbs;
